// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.headerDiv{
    display: flex;
    background-color: transparent;
    justify-content: left;
    align-items: baseline;
    gap: 10px;
    font-size: 12px;
}
.HeaderInfo{
    display: flex;
    justify-content: left;
    align-items: baseline;
    gap: 5px; 
}
.headerButton{
    /* margin-left: 5px; */
    
    display: flex;
    background-color: white;
    border-radius: 8px;
    width: 24px;
    height: 24px;
    color:black;
    align-items: center;
    justify-content: center;
    /* 
    display: flex; */
    border: none;
}
.extraButtonStyle{
    /* margin-left: 5px; */
    background-color:transparent;
    display: flex;
    background-color: transparent;
    border-radius: 8px;
    width: 24px;
    height: 24px;
    color:black;
    align-items: center;
    justify-content: center;
    /* 
    display: flex; */
    border: none;
}

.card-header{
    background-color: #A0CED9;
}

#cardHeader{
    display: flex;
    background-color: #D2E0E3;
    border: none;
    justify-content: space-between;
}
.extraButton{
    display: flex;
    gap: 10px;
}

.card{
    border-radius:20px;
    border:none;
    /* padding: 10px; */
    background-color:#D2E0E3;
}

.card-body{
    padding: 2%;
}
.container{
    padding: 0px;
   
}

.card-header{
    border-radius: 20px 20px 0px 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/DynamicCard/DynamicCard.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,sBAAsB;;IAEtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB;oBACgB;IAChB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB;oBACgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;;AAEhB;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":["\n\n.headerDiv{\n    display: flex;\n    background-color: transparent;\n    justify-content: left;\n    align-items: baseline;\n    gap: 10px;\n    font-size: 12px;\n}\n.HeaderInfo{\n    display: flex;\n    justify-content: left;\n    align-items: baseline;\n    gap: 5px; \n}\n.headerButton{\n    /* margin-left: 5px; */\n    \n    display: flex;\n    background-color: white;\n    border-radius: 8px;\n    width: 24px;\n    height: 24px;\n    color:black;\n    align-items: center;\n    justify-content: center;\n    /* \n    display: flex; */\n    border: none;\n}\n.extraButtonStyle{\n    /* margin-left: 5px; */\n    background-color:transparent;\n    display: flex;\n    background-color: transparent;\n    border-radius: 8px;\n    width: 24px;\n    height: 24px;\n    color:black;\n    align-items: center;\n    justify-content: center;\n    /* \n    display: flex; */\n    border: none;\n}\n\n.card-header{\n    background-color: #A0CED9;\n}\n\n#cardHeader{\n    display: flex;\n    background-color: #D2E0E3;\n    border: none;\n    justify-content: space-between;\n}\n.extraButton{\n    display: flex;\n    gap: 10px;\n}\n\n.card{\n    border-radius:20px;\n    border:none;\n    /* padding: 10px; */\n    background-color:#D2E0E3;\n}\n\n.card-body{\n    padding: 2%;\n}\n.container{\n    padding: 0px;\n   \n}\n\n.card-header{\n    border-radius: 20px 20px 0px 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
